import React from 'react';

type ModelTagContextType = {
  areTagsUpdated: boolean;
  setAreTagsUpdated: React.Dispatch<React.SetStateAction<boolean>>;
};

const ModelTagContext = React.createContext<ModelTagContextType | undefined>(undefined);

const ModelTagProvider = ({ children }: { children: React.ReactNode }) => {
  const [areTagsUpdated, setAreTagsUpdated] = React.useState(true);

  const value = {
    areTagsUpdated,
    setAreTagsUpdated,
  };

  return <ModelTagContext.Provider value={value}>{children}</ModelTagContext.Provider>;
};

const useModelTags = () => {
  const context = React.useContext(ModelTagContext);
  if (!context) {
    throw new Error('useModelTags must be used within a ModelTagProvider');
  }
  return context;
};

export { ModelTagProvider, useModelTags };
